import React from 'react';
import { Building2, ShieldCheck, Activity } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const metrics: { icon: LucideIcon; value: string; label: string; detail: string }[] = [
  {
    icon: Building2,
    value: '340+',
    label: 'Empresas Ativas',
    detail: 'Operações em escala nacional',
  },
  {
    icon: Activity,
    value: '99,97%',
    label: 'Uptime SLA',
    detail: 'Disponibilidade contratual',
  },
  {
    icon: ShieldCheck,
    value: 'ISO 27001',
    label: 'Certificado',
    detail: 'Segurança e conformidade',
  },
];

export function SiteTrustMetricsBar() {
  return (
    <div className="border-y border-slate-200/80 bg-slate-50/90 py-2">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 py-6 sm:grid-cols-3 sm:gap-4 sm:py-8">
          {metrics.map((m) => {
            const Icon = m.icon;
            return (
              <div
                key={m.label}
                className="flex flex-col items-center justify-center text-center sm:px-4"
              >
                <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl border border-slate-200/80 bg-white shadow-sm">
                  <Icon size={22} className="text-blue-600" strokeWidth={1.75} />
                </div>
                <p className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{m.value}</p>
                <p className="mt-1 text-base font-semibold text-slate-800 sm:text-lg">{m.label}</p>
                <p className="mt-0.5 text-sm text-slate-500">{m.detail}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
